import api from '../../../utils/api';

const route = '/admin/fa_questions';

export const getFaqApi = (params) => api.get(route, { params });
export const createFaqApi = (data) => api.post(route, data);
export const updateFaqApi = (id, data) => api.put(`${route}/${id}`, data);
export const deleteFaqApi = (id) => api.delete(`${route}/${id}`);
export const getFaqByIdApi = (id) => api.get(`${route}/${id}`);
